import { createSelector } from "@ngrx/store";
import { AppState } from "../app.reducer";


export const selectMtmaDeviceState = (state: AppState) =>
  state.deviceMtma;

export const selectMtmaUploadResponseData = createSelector(
  selectMtmaDeviceState,
  (state) => state.mtmaUploadResponseData
);